module.exports = __webpack_public_path__ + "img/roger-profile.919531a.jpg";